import React, { useState } from "react";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import "../../style/myStyle.css"; // Importa il tuo file CSS
import { useNavigate } from "react-router-dom";
import renderNotification from "../../utils/notification-handler";
import { ReactNotifications } from "react-notifications-component";
import CardContent from "@mui/material/CardContent";
import Card from "@mui/material/Card";
import { styled } from "@mui/material/styles";
import { useCSRFToken } from "../../utils/csrf-context";
import Background from "../../components/Background";

import API from "../../api/index";

const useStyles = styled((theme) => ({
  root: {
    "& label.Mui-focused": {
      color: "green", // Change label color here
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "green", // Change underline color here
    },
    "& .MuiOutlinedInput-root": {
      "&.Mui-focused fieldset": {
        borderColor: "green", // Change border color for outlined variant here
      },
    },
  },
}));

function Copyright(props) {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      align="center"
      {...props}
    >
      {"Copyright © "}
      <Link color="inherit" href="https://lecs.io/">
        Cyber Evolution SRL
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

const StyledCard = styled(Card)`
  flex: 1;
  width: auto;
  height: auto;
  margin-top: 150px;
  background-color: #000;
  border-radius: 10px;
  border: 2px solid #49BECE;

`;

const StyledText = styled(TextField)`
  & .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: #52a0a6; // Change to your desired focus color
  }
  & .MuiInputLabel-outlined.Mui-focused {
    color: #52a0a6; // Change to your desired label focus color
  }
`;

const SignIn = () => {
  const csrfToken = useCSRFToken();
  const navigate = useNavigate();
  const tipo = window.sessionStorage.getItem("type");
  const handleSubmit = (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    API.login({
      email: data.get("email"),
      psw: data.get("password"),
      type: tipo,
    }, csrfToken)
      .then((res) => {
        sessionStorage.setItem("commercial", res.data.commercial);
        sessionStorage.setItem("mfa", res.data.mfa);
        sessionStorage.setItem("sidebar", res.data.sidebar ?? false);
        navigate(`/${tipo}/twofactorauthentication`, {
          state: { from: `/${tipo}/login` },
        });
      })
      .catch(() => {
        renderNotification(
              "error",
              "Warning",
              "Credentials are not set"
            );
      });
  };

  const [showPassword, setShowPassword] = useState(false);

  const handleTogglePassword = () => {
    setShowPassword(!showPassword);
  };

  const classes = useStyles();

  return (
    <div className="app-container" style={{justifyContent: 'center', display: 'flex', alignItems: 'center'}}>
    <Background />
      <ReactNotifications />
      <Container component="main" maxWidth="xs">
        <StyledCard>
          <CardContent>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <img
                src="/logoWhite.png"
                alt="LECS"
                style={{ width: "auto", height: "45px", marginBottom: "10px" }}
              />
             
              <Typography component="h1" variant="h5" fontWeight={700}>
                Sign in
              </Typography>
              <Box
                component="form"
                onSubmit={handleSubmit}
                noValidate
                sx={{ mt: 1 }}
              >
                <StyledText
                  margin="normal"
                  required
                  fullWidth
                  id="email"
                  label="Email Address"
                  name="email"
                  autoComplete="email"
                  autoFocus
                  className={classes.root}
                />
                <StyledText
                  margin="normal"
                  required
                  fullWidth
                  name="password"
                  label="Password"
                  type={showPassword ? "text" : "password"}
                  id="password"
                  autoComplete="current-password"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          edge="end"
                          aria-label="toggle password visibility"
                          onClick={handleTogglePassword}
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
                <Button
                  type="submit"
                  variant="contained"
                  fullWidth
                  sx={{
                    backgroundColor: "#2d2d2d !important",
                    mt: 3,
                    mb: 2,
                    "&:hover": {
                      backgroundColor: "#eaeaea !important",
                      color: "#131C2D",
                    },
                  }}
                  style={{ fontWeight: "bold" }}
                >
                  Sign In
                </Button>
                <Grid container>
                  <Grid size={{md:6}}>
                    <Link
                      href={`/${tipo}/forgotPassword`}
                      style={{
                        color: "#49BECE",
                      }}
                      variant="body2"
                    >
                      Forgot password?
                    </Link>
                  </Grid>
                  <Grid size={{md:6}}>
                    <Link
                      href={`/${tipo}/registration`}
                      style={{
                        color: "#49BECE",
                      }}
                      variant="body2"
                    >
                      {"Don't have an account? Sign Up"}
                    </Link>
                  </Grid>
                </Grid>
              </Box>
            </Box>
          </CardContent>
        </StyledCard>
        <Copyright sx={{ mt: 8, mb: 4 }} />

        {/* Privacy, EULA, SLA links */}
        <Box sx={{ mt: 2, textAlign: "center" }}>
          <Typography variant="body2" sx={{ color: "text.secondary" }}>
            <Link href="/PRIVACY.html" target="_blank" rel="noopener noreferrer" sx={{ color: "text.secondary", mr: 1 }}>
              Privacy
            </Link>
            &
            <Link href="/EULA.html" target="_blank" rel="noopener noreferrer" sx={{ color: "text.secondary", mx: 1 }}>
              EULA
            </Link>
            &
            <Link href="/SLA.html" target="_blank" rel="noopener noreferrer" sx={{ color: "text.secondary", ml: 1 }}>
              SLA
            </Link>
          </Typography>
        </Box>
      </Container>
    </div>
  );
};

export default SignIn;
